import React, { useState } from "react";

// Állítsd be a saját Firebase configodat!

import { useLanguage } from "../LanguageProvider";
import { db, auth, functions } from "../firebase-config";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { setDoc, doc } from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import axios from "axios";

function generatePartnerCode(name) {
  // Egyszerű partnerkód generálás: név + random szám
  return (
    name?.toLowerCase().replace(/[^a-z0-9]/g, "") || "partner"
  ) + Math.floor(100 + Math.random() * 900);
}

// UTM source extraction helper
function getUtmSource() {
  if (typeof window !== 'undefined') {
    const params = new URLSearchParams(window.location.search);
    return params.get('utm_source') || '';
  }
  return '';
}

export default function AffiliateRegister({ onClose, setShowModal }) {
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    phone: "",
    date_of_birth: "",
    source: "",
    type: "",
    referral_code: "",
    checkbox_7f44: false,
    mobilhaz_merete_negyzetmeterben: "",
    mobilhaz_erteke: "",
    hol_hallotal_rolunk: "",
    van_telked_csak_telekkel_rendelkezok_tarthanak_igenyt_mobilhazrra: false,
    registration_purpose: ""
  });
  const [selectedPurpose, setSelectedPurpose] = useState("");
  const [partnerCode, setPartnerCode] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const { dict } = useLanguage();
  const t = dict.affiliateRegister || {};
  
  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
    if (e.target.name === "name") {
      setPartnerCode(generatePartnerCode(e.target.value));
    }
  }
  // Telefonszám formázás és validáció
  function formatPhoneNumber(phone) {
    // Eltávolítjuk a nem számokat
    const cleaned = phone.replace(/\D/g, '');
    
    // Ha 06-tal kezdődik, lecseréljük +36-ra
    if (cleaned.startsWith('06')) {
      return '+36' + cleaned.substring(2);
    }
    
    // Ha 36-tal kezdődik, hozzáadjuk a +-t
    if (cleaned.startsWith('36')) {
      return '+' + cleaned;
    }
    
    // Ha nem +36-tal kezdődik, hozzáadjuk
    if (!cleaned.startsWith('36')) {
      return '+36' + cleaned;
    }
    
    return '+' + cleaned;
  }

  function validatePhoneNumber(phone) {
    const cleaned = phone.replace(/\D/g, '');
    // Magyar telefonszám: +36 + 9 számjegy (30, 31, 70, stb.)
    return cleaned.length >= 11 && cleaned.startsWith('36');
  }

  async function handleSubmit(e) {
    e.preventDefault();
    
    // Kötelező validáció: telefonszám kötelező és formátum ellenőrzés
    if (!form.phone) {
      alert("A telefonszám megadása kötelező!");
      return;
    }
    
    const formattedPhone = formatPhoneNumber(form.phone);
    if (!validatePhoneNumber(formattedPhone)) {
      alert("Kérjük, adj meg egy érvényes magyar telefonszámot! (pl. +36301234567)");
      return;
    }
    
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref") || "";
    
    try {
      const source = getUtmSource();
      let userCredential, user;
      
      try {
        userCredential = await createUserWithEmailAndPassword(auth, form.email, form.password);
        user = userCredential.user;
      } catch (authErr) {
        alert("Hiba a felhasználó létrehozásánál: " + (authErr.message || authErr.code));
        return;
      }
      
      // Minden adat mentése Firebase-be (GHL nélkül)
      try {
        const userData = {
          name: form.name,
          fullName: form.name,
          email: form.email,
          phone: formattedPhone,
          role: 'affiliate',
          createdAt: new Date(),
          joinedAt: new Date(),
          isActive: true,
          emailVerified: false,
          affiliateId: user.uid,
          partnerCode: generatePartnerCode(form.name),
          // Minden további adat mentése
          dateOfBirth: form.date_of_birth || null,
          source: source || null,
          referralCode: ref || form.referral_code || null,
          registrationPurpose: form.registration_purpose || null,
          // Custom fields
          acceptedTerms: form.checkbox_7f44 || false,
          mobileHomeSize: form.mobilhaz_merete_negyzetmeterben || null,
          mobileHomeValue: form.mobilhaz_erteke || null,
          hearAboutUs: form.hol_hallotal_rolunk || null,
          hasLand: form.van_telked_csak_telekkel_rendelkezok_tarthanak_igenyt_mobilhazrra || false,
          // Egyéb mezők
          balance: 0,
          totalClicks: 0,
          affiliates: []
        };

        await setDoc(doc(db, "affiliates", user.uid), userData);
        
        // Mentés a users kollekcióba is a teljes láthatóság érdekében
        await setDoc(doc(db, "users", user.uid), {
          ...userData,
          role: 'affiliate'
        });
        
      } catch (fsErr) {
        alert("Hiba az adatok mentésénél: " + (fsErr.message || fsErr.code));
        return;
      }
      
      // Email verification küldése
      try {
        if (user && user.email) {
          const { sendEmailVerification } = await import('firebase/auth');
          await sendEmailVerification(user);
        }
      } catch (emailErr) {
        // Email verification hiba nem blokkolja a regisztrációt
        console.log('Email verification hiba:', emailErr);
      }
      
      setPartnerCode(generatePartnerCode(form.name));
      setSubmitted(true);
      setForm({ 
        name: "", 
        email: "", 
        password: "", 
        phone: "",
        date_of_birth: "",
        source: "",
        type: "",
        referral_code: "",
        checkbox_7f44: false,
        mobilhaz_merete_negyzetmeterben: "",
        mobilhaz_erteke: "",
        hol_hallotal_rolunk: "",
        van_telked_csak_telekkel_rendelkezok_tarthanak_igenyt_mobilhazrra: false,
        registration_purpose: ""
      });
    } catch (mainErr) {
      console.error('Regisztrációs hiba:', mainErr);
      alert('Váratlan hiba a regisztrációs folyamatban!');
    }
  }

  if (submitted) {
    return (
      <div className="min-h-[40vh] flex flex-col items-center justify-center">
        <div className="bg-green-100 border border-green-400 rounded-2xl shadow-xl p-4 flex flex-col items-center max-w-[320px] w-full">
          <div className="text-green-600 text-4xl mb-1">✔️</div>
          <h2 className="text-xl font-extrabold mb-1 text-green-900 text-center leading-tight">{t.successTitle || "Sikeres regisztráció!"}</h2>
          <p className="text-green-800 text-center mb-1 text-sm">{t.successDesc || "Köszönjük, hogy csatlakoztál az affiliate programhoz."}</p>
          <div className="my-1 px-3 py-1 bg-white border border-green-400 rounded-xl font-mono text-green-800 shadow text-base select-all">
            {t.partnerCode || "Partnerkódod"}: {partnerCode}
          </div>
          <p className="mt-2 text-xs text-gray-500 text-center">{t.successInfo || "Hamarosan emailben kapsz további információkat."}</p>
        </div>
      </div>
    );
  }

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
    if (setShowModal) {
      setShowModal(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      {/* Page header */}
      <div className="border-b border-white/[0.06] px-6 py-5">
        <h1 className="text-2xl font-black text-white">Affiliate Regisztráció</h1>
        <p className="text-[#9ca3af] text-sm mt-1">Csatlakozz az ajánlói programunkhoz</p>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-6">
        {/* Early Registration Promotion Banner */}
        <div className="max-w-2xl mx-auto mb-6 bg-gradient-to-r from-[#e31937] to-[#b40000] rounded-xl p-4 shadow-xl border border-red-400/30">
          <div className="text-center">
            <div className="flex items-center justify-center gap-2 mb-2">
              <span className="text-lg">🎁</span>
              <h3 className="text-lg font-bold text-white">
                Most regisztrálsz? Az induláskor az első 5 hirdetésed ingyen lesz!
              </h3>
            </div>
            <p className="text-white/90 text-sm mb-2">
              Csak a korai felhasználóknak, <span className="font-bold text-yellow-200">2025. szeptember 30-ig</span>
            </p>
            <div className="bg-white/20 rounded-lg p-2 backdrop-blur-sm">
              <p className="text-white text-xs font-medium">
                ⚡ Korai regisztrációs előny – ne maradj le!
              </p>
            </div>
          </div>
        </div>

        <div className="max-w-2xl mx-auto bg-[#161616] backdrop-blur-xl rounded-2xl shadow-2xl border border-white/[0.08] overflow-hidden">
          <div className="p-6">
            <div className="text-center mb-6">
              <h1 className="text-2xl font-bold text-white mb-2">{t.title || "Affiliate regisztráció"}</h1>
              <p className="text-gray-300 text-sm">{t.desc || "Csatlakozz a Hopp Homes ajánlói programhoz és szerezz jutalékot!"}</p>
            </div>

            {/* Registration Purpose Selection */}
            <div className="mb-8">
              <h2 className="text-xl font-bold text-white mb-4 text-center">Miért szeretnél regisztrálni?</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Property Seller Option */}
                <div 
                  className={`relative p-6 rounded-xl border-2 cursor-pointer transition-all duration-300 ${
                    selectedPurpose === 'property_seller' 
                      ? 'border-[#e31937] bg-[#e31937]/10 shadow-lg transform scale-105' 
                      : 'border-white/[0.08] bg-white/5 hover:border-white/40 hover:bg-white/10'
                  }`}
                  onClick={() => {
                    setSelectedPurpose('property_seller');
                    setForm({...form, registration_purpose: 'property_seller'});
                  }}
                >
                  <div className="text-center">
                    <div className="text-4xl mb-3">🏠</div>
                    <h3 className="text-lg font-bold text-white mb-2">Ingatlant szeretnék eladni</h3>
                    <p className="text-gray-300 text-sm">
                      Házat, lakást vagy telket szeretnék hirdetni és eladni a platformon
                    </p>
                  </div>
                  {selectedPurpose === 'property_seller' && (
                    <div className="absolute top-3 right-3">
                      <div className="w-6 h-6 bg-[#e31937] rounded-full flex items-center justify-center">
                        <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                      </div>
                    </div>
                  )}
                </div>

                {/* Mobile Home Buyer Option */}
                <div 
                  className={`relative p-6 rounded-xl border-2 cursor-pointer transition-all duration-300 ${
                    selectedPurpose === 'mobile_home_buyer' 
                      ? 'border-[#e31937] bg-[#e31937]/10 shadow-lg transform scale-105' 
                      : 'border-white/[0.08] bg-white/5 hover:border-white/40 hover:bg-white/10'
                  }`}
                  onClick={() => {
                    setSelectedPurpose('mobile_home_buyer');
                    setForm({...form, registration_purpose: 'mobile_home_buyer'});
                  }}
                >
                  <div className="text-center">
                    <div className="text-4xl mb-3">🏘️</div>
                    <h3 className="text-lg font-bold text-white mb-2">Mobilházat szeretnék vásárolni</h3>
                    <p className="text-gray-300 text-sm">
                      Mobilházat szeretnék vásárolni vagy ajánlani másoknak jutalékért
                    </p>
                  </div>
                  {selectedPurpose === 'mobile_home_buyer' && (
                    <div className="absolute top-3 right-3">
                      <div className="w-6 h-6 bg-[#e31937] rounded-full flex items-center justify-center">
                        <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              
              {selectedPurpose && (
                <div className="mt-4 p-4 bg-green-500/10 border border-green-500/30 rounded-lg">
                  <div className="flex items-center gap-2">
                    <svg className="w-5 h-5 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <span className="text-green-300 font-medium">
                      {selectedPurpose === 'property_seller' 
                        ? 'Kiváló! Segítünk eladni az ingatlanodat és jutalékot keresel minden sikeres ügylettel.'
                        : 'Szuper! Mobilházakat ajánlhatsz és vásárolhatsz, minden ügylet után jutalékot kapsz.'
                      }
                    </span>
                  </div>
                </div>
              )}
            </div>
            
            <form
              id="affiliate-form"
              className="grid grid-cols-1 md:grid-cols-2 gap-4"
              onSubmit={handleSubmit}
              autoComplete="off"
            >
        <div className="flex flex-col gap-2 w-full">
          <label htmlFor="name" className="text-white font-medium text-xs">
            {t.name || "Név"} <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="name"
            id="name"
            required
            value={form.name}
            onChange={handleChange}
            className="rounded-lg px-3 py-2 bg-white border border-gray-200 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent placeholder-gray-400 font-medium text-sm shadow-sm transition-all duration-200 text-black"
            placeholder={t.namePlaceholder || "Pl. Kovács Béla"}
          />
        </div>
        <div className="flex flex-col gap-2 w-full">
          <label htmlFor="email" className="text-white font-medium text-xs">
            {t.email || "Email"} <span className="text-red-500">*</span>
          </label>
          <input
            type="email"
            name="email"
            id="email"
            required
            value={form.email}
            onChange={handleChange}
            className="rounded-lg px-3 py-2 bg-white border border-gray-200 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent placeholder-gray-400 font-medium text-sm shadow-sm transition-all duration-200 text-black"
            placeholder={t.emailPlaceholder || "email@pelda.hu"}
          />
        </div>
        <div className="flex flex-col gap-2 w-full">
          <label htmlFor="password" className="text-white font-medium text-xs">
            {t.password || "Jelszó"} <span className="text-red-500">*</span>
            <span className="text-xs text-gray-500 font-normal ml-1">(min. 6 karakter)</span>
          </label>
          <input
            type="password"
            name="password"
            id="password"
            required
            minLength={6}
            value={form.password}
            onChange={handleChange}
            className="rounded-lg px-3 py-2 bg-white border border-gray-200 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent placeholder-gray-400 font-medium text-sm shadow-sm transition-all duration-200 text-black"
            placeholder={t.passwordPlaceholder || "Jelszó"}
          />
        </div>
        <div className="flex flex-col gap-2 w-full">
          <label htmlFor="phone" className="text-white font-medium text-xs">
            Telefonszám <span className="text-red-500">*</span>
          </label>
          <input
            type="tel"
            name="phone"
            id="phone"
            required
            value={form.phone}
            onChange={handleChange}
            className="rounded-lg px-3 py-2 bg-white border border-gray-200 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent placeholder-gray-400 font-medium text-sm shadow-sm transition-all duration-200 text-black"
            placeholder="+36301234567"
          />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 w-full">
          <div className="flex flex-col gap-2">
            <label htmlFor="date_of_birth" className="text-white font-medium text-xs">
              Születési dátum <span className="text-xs text-gray-500 font-normal">(opcionális)</span>
            </label>
            <input
              type="date"
              name="date_of_birth"
              id="date_of_birth"
              value={form.date_of_birth}
              onChange={handleChange}
              className="rounded-lg px-3 py-2 bg-white border border-gray-200 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent font-medium text-sm shadow-sm transition-all duration-200 text-black"
            />
          </div>
          <div className="flex flex-col gap-2">
            <label htmlFor="contact_source" className="text-white font-medium text-xs">
              Forrás <span className="text-xs text-gray-500 font-normal">(opcionális)</span>
            </label>
            <input
              type="text"
              name="contact_source"
              id="contact_source"
              value={form.contact_source}
              onChange={handleChange}
              className="rounded-lg px-3 py-2 bg-white border border-gray-200 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent placeholder-gray-400 font-medium text-sm shadow-sm transition-all duration-200 text-black"
              placeholder="Facebook, Google, stb."
            />
          </div>
        </div>
        <div className="flex flex-col gap-2 w-full">
          <label htmlFor="referral_code" className="text-white font-medium text-xs">
            Ajánlói kód <span className="text-xs text-gray-500 font-normal">(opcionális)</span>
          </label>
          <input
            type="text"
            name="referral_code"
            id="referral_code"
            value={form.referral_code}
            onChange={handleChange}
            className="rounded-lg px-3 py-2 bg-white border border-gray-200 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent placeholder-gray-400 font-medium text-sm shadow-sm transition-all duration-200 text-black"
            placeholder="Ajánlói kód (ha van)"
          />
        </div>
        {/* CUSTOM FIELDS START */}
        <div className="flex items-center gap-3 w-full">
          <input
            type="checkbox"
            name="checkbox_7f44"
            id="checkbox_7f44"
            checked={form.checkbox_7f44}
            onChange={e => setForm({ ...form, checkbox_7f44: e.target.checked })}
            className="w-5 h-5 text-green-600 border-gray-300 rounded focus:ring-green-500"
          />
          <label htmlFor="checkbox_7f44" className="text-white font-medium text-xs cursor-pointer">
            <span>Elfogadom az általános szerződési feltételeket</span>
            <span className="text-xs text-gray-500">(opcionális)</span>
          </label>
        </div>
        <div className="flex flex-col gap-2 w-full">
          <label htmlFor="mobilhaz_merete_negyzetmeterben" className="text-white font-medium text-xs">
            Mobilház mérete (m²) <span className="text-xs text-gray-500 font-normal">(opcionális)</span>
          </label>
          <select
            name="mobilhaz_merete_negyzetmeterben"
            id="mobilhaz_merete_negyzetmeterben"
            value={form.mobilhaz_merete_negyzetmeterben}
            onChange={handleChange}
            className="rounded-lg px-3 py-2 bg-white border border-gray-200 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent font-medium text-sm shadow-sm transition-all duration-200 text-black"
          >
            <option value="">Válassz méretet</option>
            <option value="35">35</option>
            <option value="40">40</option>
            <option value="45">45</option>
            <option value="50">50</option>
            <option value="55">55</option>
            <option value="60">60</option>
            <option value="65">65</option>
            <option value="70">70</option>
            <option value="75">75</option>
            <option value="82">82</option>
          </select>
        </div>
        <div className="flex flex-col gap-2 w-full">
          <label htmlFor="partner_code" className="text-white font-medium text-xs">
            Partner kód <span className="text-xs text-gray-500 font-normal">(opcionális)</span>
          </label>
          <input
            type="text"
            name="partner_code"
            id="partner_code"
            value={form.partner_code}
            onChange={handleChange}
            className="rounded-lg px-3 py-2 bg-white border border-gray-200 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent placeholder-gray-400 font-medium text-sm shadow-sm transition-all duration-200 text-black"
            placeholder="Partner kód (ha van)"
          />
        </div>
        <div className="flex flex-col gap-2 w-full">
          <label htmlFor="mobilhaz_erteke" className="text-white font-medium text-xs">
            Mobilház értéke <span className="text-xs text-gray-500 font-normal">(opcionális)</span>
          </label>
          <select
            name="mobilhaz_erteke"
            id="mobilhaz_erteke"
            value={form.mobilhaz_erteke}
            onChange={handleChange}
            className="rounded-lg px-3 py-2 bg-white border border-gray-200 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent font-medium text-sm shadow-sm transition-all duration-200 text-black"
          >
            <option value="">Válassz értéket</option>
            <option value="10-15 millió">10-15 millió</option>
            <option value="16-25 millió">16-25 millió</option>
            <option value="26 millió felett">26 millió felett</option>
          </select>
        </div>
        <div className="flex flex-col gap-2 w-full">
          <label htmlFor="hol_hallotal_rolunk" className="text-white font-medium text-xs">
            Hol hallottál rólunk? <span className="text-xs text-gray-500 font-normal">(opcionális)</span>
          </label>
          <select
            name="hol_hallotal_rolunk"
            id="hol_hallotal_rolunk"
            value={form.hol_hallotal_rolunk}
            onChange={handleChange}
            className="rounded-lg px-3 py-2 bg-white border border-gray-200 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent font-medium text-sm shadow-sm transition-all duration-200 text-black"
          >
            <option value="">Válassz csatornát</option>
            <option value="Facebook">Facebook</option>
            <option value="Instagram">Instagram</option>
            <option value="TikTok">TikTok</option>
            <option value="YouTube">YouTube</option>
          </select>
        </div>
        <div className="flex flex-col gap-1 w-full">
          <label htmlFor="van_telked_csak_telekkel_rendelkezok_tarthanak_igenyt_mobilhazrra" className="text-gray-900 font-bold text-base flex items-center gap-2">
            <span>Van telked? (Csak telekkel rendelkezők tarthatnak igényt mobilházra)</span>
            <span className="text-xs text-gray-500">(opcionális)</span>
          </label>
          <input
            type="checkbox"
            name="van_telked_csak_telekkel_rendelkezok_tarthanak_igenyt_mobilhazrra"
            id="van_telked_csak_telekkel_rendelkezok_tarthanak_igenyt_mobilhazrra"
            checked={form.van_telked_csak_telekkel_rendelkezok_tarthanak_igenyt_mobilhazrra}
            onChange={e => setForm({ ...form, van_telked_csak_telekkel_rendelkezok_tarthanak_igenyt_mobilhazrra: e.target.checked })}
            className="w-5 h-5 text-green-600 border-gray-300 rounded focus:ring-green-500"
          />
        </div>
        {/* CUSTOM FIELDS END */}
        {partnerCode && (
          <div className="w-full flex flex-col items-start gap-2">
            <label htmlFor="partnerCode" className="text-gray-900 font-bold text-base">{t.partnerCode || "Partnerkód"}</label>
            <div className="px-4 py-2 bg-green-100 border border-green-400 rounded-xl font-mono text-green-800 shadow text-lg select-all">
              {partnerCode}
            </div>
            <span className="text-xs text-gray-500">{t.partnerCodeHint || "Ezt a kódot fogod használni az ajánlásokhoz."}</span>
          </div>
        )}
            </form>
            
            <button
              type="submit"
              form="affiliate-form"
              className="mt-6 w-full bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white font-semibold py-4 rounded-lg shadow-lg text-base tracking-wide transition-all duration-200 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
            >
              {t.submit || "Regisztráció"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
